<template>
  <template v-if="sidebarComponents.length === 0 && variants.v1 === variant"
>
    <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor}, var(--c-section_primary))`">
      <div class="container">
        <!-- Header -->
        <div class="row justify-between items-center">
          <!-- Başlık -->
          <div class="col-auto" v-html="vars.titleHtml"></div>
          
        </div>

        <!-- Slider -->
        <div
          class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
          data-gap="30"
          data-slider-cols="xl-2 lg-2 md-2 sm-2 base-1"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(card, index) in cards" :key="index">
              <div class="imageCard -type-2 cursor-pointer" @click.prevent="handleCardClick(card)">
                <div>
                  <library-image :src="card.photo" :w-ratio="7" :h-ratio="4" :alt="card.title" />
                </div>
                <div class="tw-h-[80px]">
                  <h5 class="imageCard__title tw-line-clamp-2">{{ card.title }}</h5>
                </div>
                <div class="mt-4">
                  
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Arrows -->
          <div class="d-flex mt-15 md:mt-5 ">
            <button
              class="sliderNav -prev js-prev n-link !tw-bg-transparent "
              style="border-color: #EF787C !important"
            >
              <i class="icon-left-arrow"></i>
            </button>
            <button
              style="border-color: #EF787C !important"
              class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent "
            >
              <i class="icon-right-arrow"></i>
            </button>
          </div>

          <!-- Mobile Buttons -->
        
        </div>

        <!-- Popup -->
        
      </div>
    </section>


  </template>
  <template v-if="sidebarComponents.length === 0 && variants.v2 === variant"
>
    <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor}, var(--c-section_primary))`">
      <div class="container">
        <!-- Header -->
        <div class="row justify-between items-center">
          <!-- Başlık -->
          <div class="col-auto" v-html="vars.titleHtml"></div>
          
        </div>

        <!-- Slider -->
        <div
          class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
          data-gap="30"
          data-slider-cols="xl-2 lg-2 md-2 sm-2 base-1"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(card, index) in cards" :key="index">
              <div class="imageCard -type-2 cursor-pointer" @click.prevent="handleCardClick(card)">
                <div>
                  <library-image :src="card.photo" :w-ratio="7" :h-ratio="4" :alt="card.title" />
                </div>
                <div class="tw-h-[80px]">
                  <h5 class="imageCard__title tw-line-clamp-2">{{ card.title }}</h5>
                </div>
                <div class="mt-4">
                  
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Arrows -->
          <div class="d-flex mt-15 md:mt-5 ">
           <button
  class="sliderNav -prev js-prev n-link !tw-bg-transparent"
  :style="`border-color: var(--c-${vars.borderColor}) !important`"
  @mouseover="
    $event.currentTarget.style.setProperty('background-color', `var(--c-${vars.borderColor})`, 'important');
    $event.currentTarget.style.setProperty('border-color', `var(--c-${vars.borderColor})`, 'important');
  "
  @mouseout="
    $event.currentTarget.style.setProperty('background-color', 'transparent', 'important');
    $event.currentTarget.style.setProperty('border-color', `var(--c-${vars.borderColor})`, 'important');
  "
>
  <i class="icon-left-arrow"></i>
</button>

<button
  class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent"
  :style="`border-color: var(--c-${vars.borderColor}) !important`"
  @mouseover="
    $event.currentTarget.style.setProperty('background-color', `var(--c-${vars.borderColor})`, 'important');
    $event.currentTarget.style.setProperty('border-color', `var(--c-${vars.borderColor})`, 'important');
  "
  @mouseout="
    $event.currentTarget.style.setProperty('background-color', 'transparent', 'important');
    $event.currentTarget.style.setProperty('border-color', `var(--c-${vars.borderColor})`, 'important');
  "
>
  <i class="icon-right-arrow"></i>
</button>

          </div>

          <!-- Mobile Buttons -->
        
        </div>

        <!-- Popup -->
        
      </div>
    </section>


  </template>


</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import Popup from '~/components/common/popup/Popup.vue';
import { mapStores, mapState } from 'pinia';
import { Pagination as SwiperPagination } from 'swiper/modules';

export default defineNuxtComponent({
  name: 'CustomSliderWithPopup',
  mixins: [ComponentMixin],
  components: { Popup },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      selectedCard: null,
      popupConfig: { isActive: false },
      swiperModules: [SwiperPagination],
       variants: { v1: 'v1', v2: 'v2'},
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    ...mapStores(useWebsiteStore),

    sidebarComponents() {
      return this.websiteStore.sidebarComponents;
    },

    cards() {
      return this.groupedVariables.cards;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  methods: {
    handleCardClick(card: any) {
      // Always open popup for cards
      this.selectedCard = { ...card, formData: this.parseFormV2(card.guide || card.form) };
      this.popupConfig.isActive = true;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },

    slidePrev() {
      try {
        if (this.swiper) {
          this.swiper.slidePrev();
        }
      } catch (error) {
        console.error('Error in slidePrev:', error);
      }
    },

    slideNext() {
      try {
        if (this.swiper) {
          this.swiper.slideNext();
        }
      } catch (error) {
        console.error('Error in slideNext:', error);
      }
    },
  },
});
</script>
